import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { AddressesPageContext } from "@insite/content-library/Pages/AddressesPage";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { gridGapStyles } from "@store/theme/common/mixins";
import { COMMON } from "@store/theme/design";
import getWidgetComponent from "@store/utilities/getWidgetComponent";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const CurrentBillingAddress = getWidgetComponent("Addresses/CurrentBillingAddress");
const CurrentShippingAddress = getWidgetComponent("Addresses/CurrentShippingAddress");

export interface CurrentAddressesStyles {
    container?: GridContainerProps;
    shippingAddressGridItem?: GridItemProps;
    billingAddressGridItem?: GridItemProps;
}

export const currentAddressesStyles: CurrentAddressesStyles = {
    container: {
        gap: 0,
        css: css`
            ${gridGapStyles(["30px"], COMMON.spacing.content.slice(0, 1))}
        `,
    },
    shippingAddressGridItem: {
        width: [12, 6, 12, 6, 6],
    },
    billingAddressGridItem: {
        width: [12, 6, 12, 6, 6],
    },
};

const styles = currentAddressesStyles;

const CurrentAddresses: React.FunctionComponent = () => {
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.billingAddressGridItem}>
                <CurrentBillingAddress />
            </GridItem>
            <GridItem {...styles.shippingAddressGridItem}>
                <CurrentShippingAddress />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect()(CurrentAddresses),
    definition: {
        displayName: "Current Addresses",
        group: "Addresses",
        allowedContexts: [AddressesPageContext],
    },
};

export default widgetModule;
